"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSingleValue = parseSingleValue;
exports.default = parse;
exports.stringify = stringify;
exports.getValidMomentDate = getValidMomentDate;
exports.parseTime = parseTime;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _moment = _interopRequireWildcard(require("moment"));

function parseFormat(value, format, strict) {
  var m = (0, _moment.default)(value, format, strict);

  if (m.isValid()) {
    return m;
  }
}

function parseMoment(value) {
  if ((0, _moment.isMoment)(value)) {
    return value;
  }
}

function parseSingleValue(value, strict) {
  if (typeof value === 'string') {
    value = value.trim();
  }

  if (value) {
    var format = _moment.default.localeData().longDateFormat('L');

    return parseMoment(value) || parseFormat(value, format, strict);
  }

  return undefined;
}

function parse(value) {
  var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var from, to;

  if (parseMoment(value)) {
    return {
      from: value
    };
  }

  if (value instanceof Date) {
    from = value;
    to = null;
  } else if (value instanceof Object) {
    from = value.from;
    to = value.to;
  } else if (value) {
    var values = value.trim().replace(/[^\d/\\.]+/g, '—').split('—');

    if (values.length > 2) {
      return;
    }

    var _values = (0, _slicedToArray2.default)(values, 2);

    from = _values[0];
    to = _values[1];
  }

  from = parseSingleValue(from, strict);
  to = parseSingleValue(to, strict);

  if (from > to) {
    var _ref = [to, from];
    from = _ref[0];
    to = _ref[1];
  }

  return {
    from: from,
    to: to
  };
}

function stringify(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';

  if (!value) {
    return '';
  }

  if (_moment.default.isMoment(value) || value instanceof Date) {
    return (0, _moment.default)(value).format(format);
  }

  var from = value.from,
      to = value.to;
  return stringify(from) + (to ? ' — ' + stringify(to) : '');
}

function getValidMomentDate(value) {
  if (!value) {
    return (0, _moment.default)();
  } else {
    return (0, _moment.default)(value, 'L', _moment.default.locale());
  }
}

function parseTime(value) {
  if (_moment.default.isMoment(value)) {
    return value;
  }

  if (typeof value === 'undefined') {
    return (0, _moment.default)();
  }

  var timeFormat = _moment.default.localeData().longDateFormat('LT');

  return (0, _moment.default)("2000-01-01 ".concat(value), "YYYY-MM-DD ".concat(timeFormat));
}